import { object, string } from 'yup';
import { INewUserValidationSchema } from '../interfaces/INewUserValidationSchema';

export const newUserValidationSchema = object<INewUserValidationSchema>({
  email: string().required('Email is Required'),
});

export default newUserValidationSchema;
